import { formatDateDigits, formattedDayMonth } from '../../../tools/date-format';
import { LocaleKey } from '../../../types/app-state';

type EventCardLike = {
    isOnDemand?: boolean;
    isFullyBooked?: boolean;
    eventDate?: string;
    eventLocation?: string;
};

type Localize = (key: string, fallback: string) => string;

export const getEventEyebrow = (event: EventCardLike, localize: Localize, locale: LocaleKey) => {
    if (event.isOnDemand) {
        return localize('online', 'Online');
    }
    const parts: string[] = [];
    if (event.eventDate) parts.push(formatDateDigits(event.eventDate, locale));
    if (event.eventLocation) parts.push(event.eventLocation);
    return parts.join(' | ');
};

export const getEventBadge = (event: EventCardLike, localize: Localize, locale: LocaleKey) => {
    if (event.isFullyBooked) return localize('event-fully-booked', 'Fully Booked');
    if (event.isOnDemand) return localize('on-demand', 'On demand');
    if (event.eventDate) return formattedDayMonth(event.eventDate, locale);
    return '';
};

export const getEventCardOverrides = (event: EventCardLike, localize: Localize, locale: LocaleKey) => ({
    eyebrow: getEventEyebrow(event, localize, locale),
    categoryLabel: getEventBadge(event, localize, locale),
});
